import { SvgIconTypeMap } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"

// support type definitions

export type groupFilterType = {
  data: {
    group_name: string
    group_code: number
    group_sk: number
  }[]
  selected: null | string
  accessKey: string
}
export type officesFilterType = {
  data:
  | {
    name: string
    practice_sk: number | null
  }[]
  | []
  selected: null | string
  accessKey: null | string
}
export type dateFilterType = {
  data: (string | number)[]
  selected: number | string | null
}
export const enum primaryTabs {
  clinical = "Clinical Hours",
  nonClinical = "Non Clinical Hours",
}
export const enum secondayTabs {
  doctors = "Doctors",
  hygienists = "Hygienists",
}
export const enum tabsType {
  doctors = "doctors",
  hygienists = "hygienists",
  nonClinical = "Non Clinical Hours",
}

// main type definitions

export type filtersType = {
  Groups: groupFilterType
  Offices: officesFilterType
  Regions: {
    data: string[]
    selected: null | string
    accessKey: null | string
  }
  Year: dateFilterType
  month: number
}
export type forecastFilterTypes = {
  Offices: {
    data: Array<any>
    selected: any
  }
  Year: any
  month: number
}
export type monthEditState = {
  newEntry: boolean
  dirty: string[]
  clinicalDoctors: {
    dirty: string[]
    newEntry: boolean
    data: any[]
  }
  clinicalHygienists: {
    dirty: string[]
    newEntry: boolean
    data: any[]
  }
  nonClinical: {
    dirty: string[]
    newEntry: boolean
    data: any[]
  }
  allChanges: any[]
  modifiedData: {
    doctorsData?: any[]
    hygienistsData?: any[]
    nonClinicalData?: any[]
  }
}

export type editState = {
  monthStates: Record<number, monthEditState>
  newEntry: boolean
  dirty: string[] // Changed to string[] to track cell IDs
  clinicalDoctors: {
    dirty: string[]
    newEntry: boolean
    data: any[]
  }
  clinicalHygienists: {
    dirty: string[]
    newEntry: boolean
    data: any[]
  }
  nonClinical: {
    dirty: string[]
    newEntry: boolean
    data: any[]
  }
  allChanges: any[]
}
type aggregationType = {
  [primaryTabs.nonClinical]: {
    data: any
    key: "Staff"
  }
  [secondayTabs.doctors]: {
    data: any
    key: "Doctors"
  }
  [secondayTabs.hygienists]: {
    data: any
    key: "Hygienists"
  }
}

type providersType = {
  data: [] // Kept for backward compatibility
  doctors: [] // Separate provider list for doctors
  hygienists: [] // Separate provider list for hygienists
  loading: false
}

export type primaryTabType = {
  clinical: string
  nonClinical: string
}
export interface resourceBudgetType {
  month: number
  years: []
  selectedYear: null
  resourceBudget: true
  dataIndex:
  | primaryTabs.nonClinical
  | secondayTabs.doctors
  | secondayTabs.hygienists
  primaryIndex: number
  secondaryIndex: number
  primaryTabs: string[]
  secondayTabs: string[][]
  copyTo: {
    data: any
    selectAll: boolean
    selected: number[]
  }
  data: {}[]
  published: boolean
  providerState: providersType
  aggregations: aggregationType
  editState: editState
  // Separate data storage for clinical tabs
  doctorsData?: any[]
  hygienistsData?: any[]
  // Separate data storage for non-clinical tab
  nonClinicalData?: any[]
}
export interface forecastType {
  filters: forecastFilterTypes
  dataIndex:
  | primaryTabs.nonClinical
  | secondayTabs.doctors
  | secondayTabs.hygienists
  primaryIndex: number
  secondaryIndex: number
  isLoading: boolean
  primaryTabs: string[]
  secondayTabs: string[][]
  published: true
  data: {}[]
  providerState: providersType
  aggregations: aggregationType
  confirmState: {
    providerType: "Staff member" | "Provider" | null
    open: boolean
    loading: boolean
    provider: null | string
    close: any
    actionHandler: any
  }
  editState: editState
}

export type actionType = {
  apiCall: any
  payload: any
  setSaved: any
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>
  enabled: boolean
  iconStyles?: React.CSSProperties
  test?: Function | null
  alert?: boolean
  hidden?: boolean
}
